// apps/client/src/world/objects/decor.ts — bushes, logs, crates and the like join one instanced batch per catalog id
import { InstanceProxy, modelTemplate, type ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['decor'],
  async build(obj, ctx) { return new InstanceProxy(obj.catalogId, await modelTemplate(ctx.assets, obj.catalogId)); },
};
